import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { combineData, lorem } from "../../utils";
import { default as defaultData } from "./data.json";
import { style } from "./style";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";
import { GuaranteeLayouts } from "../types";

const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: GuaranteeLayouts.TWO,
  layout: GuaranteeLayouts.TWO,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/guarantees/Guarantee02.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkzt2al72l5707802d671a78",
    itemId: "bhdxwg0xwl",
  },
  default: {
    type: ComponentTypes.SECTION,
    label: PageSectionCategory.GUARANTEE,
    bodyOnly: true,
    canHaveChildren: false,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((4 * 100) / 12),
            properties: { height: "100%", padding: 10, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.PICTURE,
                canHaveChildren: false,
                properties: {
                  display: "inline-block",
                  // width: 170,
                  padding: 15,
                  margin: "0 auto",
                  textAlign: "center",
                },
                src: "http://tenminutepages.com/images/guarantee_pic.png",
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((8 * 100) / 12),
            properties: { height: "100%", padding: 10, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.HEADLINE,
                canHaveChildren: false,
                properties: {
                  ...style.HEADLINE,
                  marginTop: 10,
                },
                html: "100% Money Back Guarantee",
              },
              {
                type: ComponentTypes.TEXT,
                canHaveChildren: false,
                properties: {
                  ...style.TEXT,
                },
                html: lorem.generateSentences(3),
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
